module.exports = __webpack_public_path__ + "static/media/01_news.b59a93d4.png";